<!-- DESARROLLLO INICIADO  31/08/2020 wuilmer garcia -->
<template>
  <div>
    <v-card>
      <!-- boton crear -->
      <v-row v-if="componenteEvento.agregar_submodulo">
        <v-col class="d-flex flex-row-reverse">
          <TableButtonComp
            @click="addItem"
            text-button="Crear competencia"
            icon-but="fas fa-plus"
            normalButton
          />
        </v-col>
      </v-row>
      <!-- fin boton  crear-->

      <!-- /////////////////////////////////////////////////////
                                                                                //             PANTALLA PRINCIPAL                  //
                                                                                /////////////////////////////////////////////////////    -->

      <ComundataTablecomp
        placeholderTextsearch="Bucar competencia"
        :items="Datos"
        :headers="AgregarCompetenciaHeaders"
        rowsPerPageText="Competencias por página:"
        noResultsText="Sin competencias por mostrar"
        whitSearch
      >
        <slot>
          <v-row>
            <v-col cols="12" md="6" sm="6">
              <AutocompleteComp
                v-model="filtro.id_pais"
                textLabel="País"
                :items="paisCurriculo"
                item-value="id_pais"
                item-text="nombre_pais"
                @change="filtroPais"
              />
            </v-col>

            <v-col cols="12" md="6" sm="6">
              <AutocompleteComp
                textLabel="Currículo nacional"
                v-model="filtro.id_curriculo"
                :items="curriculo"
                autocomplete="off"
                item-value="id"
                item-text="curriculo"
                @change="eventCurriculo"
              />
            </v-col>
          </v-row>
        </slot>

        <template v-slot:action_editar="{ item }">
          <TableButtonComp
            v-if="componenteEvento.editar_submodulo"
            @click="editItem(item)"
            editButton
            tooltip-text="Editar Competencia"
          />
        </template>

        <template v-slot:action_borrar="{ item }">
          <TableButtonComp
            v-if="componenteEvento.borrar_submodulo"
            @click="deleteConfirm(item)"
            tooltip-text="Borrar competencia"
            deleteButton
          />
        </template>
      </ComundataTablecomp>
    </v-card>
    <!-- fin de pantalla principal -->

    <!-- /////////////////////////////////////////////////////
                                                                                 //     MODAL DE AGREGAR O EDITAR          //
                                                                            ////////////////////////////////////////////////////    -->
    <v-form ref="formDatos" lazy-validation>
      <v-dialog v-model="dialog" persistent scrollable max-width="650">
        <v-card>
          <v-card-title class="btn_otro">
            <label>{{ formTitle }}</label>
            <v-spacer />
            <v-btn fab dark x-small class="btn_style3" @click="dialog = false"
              ><v-icon dark>fa-times</v-icon></v-btn
            >
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="6" class="">
                <v-autocomplete
                  v-model="dataForm.id_pais"
                  label="País"
                  :items="paisCurriculo"
                  item-value="id_pais"
                  item-text="nombre_pais"
                  :rules="[rul.required]"
                  @change="filtroFormPais"
                  :readonly="inhabilitarPais"
                  autocomplete="off"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="6" class="">
                <v-text-field
                  v-model="dataForm.curriculo"
                  label="Currículo nacional"
                  :rules="[rul.required]"
                  :readonly="inhabilitarCurriculo"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="12" class="py-0">
                <v-textarea
                  v-model="dataForm.descripcion"
                  label="Nombre de la competencia"
                  :rules="[rul.required]"
                  rows="2"
                  auto-grow
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="btn_block_style2"
              dark
              
              v-if="this.evento == 'editar'"
              @click="saveItem(dataForm.id)"
              >Guardar Cambios</v-btn
            >
            <v-btn
              class="btn_block_style2"
              dark
              
              v-if="this.evento == 'agregar'"
              @click="saveItem"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!-- fin de modal agregar o editar perfil -->

    <!-- /////////////////////////////////////////////////////
                                                                            //         MODAL DE BORRAR REGISTROS                  //
                                                                            /////////////////////////////////////////////////////    -->
    <v-dialog v-model="dialog_delete" width="550">
      <v-card>
        <v-card-title class="btn_ver">
          <label for="">Borrar registro</label>
          <v-spacer />
          <v-btn
            fab
            dark
            x-small
            class="btn_style3"
            @click="dialog_delete = false"
            ><v-icon dark>fa-times</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text class="text-center black--text pt-8">
          <h3>
            ¿Está seguro de que desea borrar este registro?
          </h3>
            <div class="py-6">
              <div class="yellow py-2 px-3  rounded-pill mx-3" style="font-size:1rem">
              <span >{{ desc_delete }}</span>
              </div>
            </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_style3" dark  @click="dialog_delete = false"
            >No</v-btn
          >
          <v-btn class="btn_block_style2" dark  @click="deleteItem"
            >Si</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- fin de modal de borrar registro -->

            <!--
                Listar Curriculo: <pre>{{curriculo}}</pre>
                Datos Form: <pre>{{dataForm}}</pre>
                Datos Listar: <pre>{{Datos}}</pre>
            -->

    <!-- modal dialogo de confirmación de COMPETENCIA --->
    <v-dialog v-model="dialog_confir" width="550">
      <v-card>
        <v-card-title class="btn_ver">
          <v-row class="d-flex justify-space-between py-0">
            Confirmar
            <v-btn
              fab
              dark
              x-small
              class="btn_style3"
              @click="dialog_confir = false"
              ><v-icon dark>fa-times</v-icon></v-btn
            >
          </v-row>
        </v-card-title>

        <v-card-text class="text-center black--text">
          <h3>¿Desea registrar otra competencia?</h3>
          <br />
          <!--
                                                                                        <v-chip :color="NewNivel.color" class="white--text"><h3>{{NewNivel.desc_nivel}}</h3></v-chip>
                                                                                        -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            class="btn_style3"
            dark
            
            @click="
              confirEvent(false);
              dialog_confir = false;
            "
            >No</v-btn
          >

          <v-btn
            class="btn_block_style2"
            dark
            
            @click="
              confirEvent(true);
              dialog_confir = false;
            "
            >Si</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--------fin modal-->
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { AgregarCompetenciaHeaders } from "./../../../../helpers/headersTable.js";
import ComundataTablecomp from "../../../../components/ComponentsEst/ComundataTablecomp.vue";
import TableButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import AutocompleteComp from "../../../../components/ComponentsEst/AutocompleteComp.vue";

// eslint-disable-next-line
import { join } from "path";

export default {
  name: "formNotaLit",

  props: ["estadoComp", "parametros"],
  components: {
    ComundataTablecomp,
    TableButtonComp,
    AutocompleteComp,
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 77, id_modulo: 4 }, //sud_modulo y modulo
    AgregarCompetenciaHeaders,
    datoLogin: sessionStorage, // variables de sesion del usuario
    /////////////////////////////////////////////////////////////

    search: "",
    Datos: [],
    filtro: {},
    pais: [],

    curriculo: [],
    paisCurriculo: [],
    listCurriculo: [],

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo requerido",
      inputReq: (value) => !!value || "Campo requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo Electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo Electrónico es incorrecto";
        }
      },
    },

    // MODAL AGREGRAR-EDITAR NOTA LITERAL
    evento: null,
    titulo: "competencias",
    dialog: false,
    formTitle: "",
    dataForm: {},

    inhabilitarPais: true,
    inhabilitarCurriculo: true,
    inhabilitarIcono: true,

    ///////////////////////////////
    dialog_confir: false,

    // MODAL BORRAR NOTA LITERAL
    dialog_delete: false,
    desc_delete: null,
    id_delete: null,
    ///////////////////////////////
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },

  watch: {
    // cada vez que la pregunta cambie desde el componente padre, esta función será ejecutada
    estadoComp() {
      if (this.estadoComp) {
        this.actualizarParamentro();
        this.loadMain();
      }
    },
  },

  mounted() {
    this.loadMain();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //  ------- MOSTRAR TODOS LOS REGISTROS    --------
    async loadMain() {
      this.filtro.id_pais = null;
      this.filtro.id_curriculo = null;

      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
      };

      try {
        let response01 = await axios.get("/manager/curriculo/ps/fil/", params);
        this.paisCurriculo = response01.data;
        //console.log(response01.data)
        this.listarCompetencias();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async listarCompetencias() {
      try {
        let params02 = { id: null, id_curriculo: null };
        let res02 = await axios.post("manager/curriculo/cr/list/", params02);
        this.listCurriculo = res02.data;
        //console.log("listar competencias")
        //console.log(res02.data)
        this.Datos = [];
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async limpiarForm() {
      this.dataForm = {
        id_usuario: this.datoLogin.id,
        id_us_ing: this.datoLogin.id,
        id_us_mod: this.datoLogin.id,
        id_pais: "",
        id_curriculo: "",
        curriculo: "",
        descripcion: "",
      };

      this.inhabilitarPais = true;
      this.inhabilitarCurriculo = true;

      this.resetValidation();
    },

    // Validar resetear campos al guardar
    resetValidation() {
      this.$refs.formDatos.resetValidation();
    },

    //////////  Filtro de curriculo por pais  /////////
    async filtroPais() {
      //console.log(`Filtro por país: ${this.filtro.id_pais}`)
      this.curriculo = this.listCurriculo.filter(
        (el) => el.id_pais == this.filtro.id_pais
      );
    },

    //////////  Filtro de curriculo por pais  /////////
    async filtroFormPais() {
      //console.log(`Filtro por país: ${this.dataForm.id_pais}`)
      let filtro = this.listCurriculo.filter(
        (el) => el.id_pais == this.dataForm.id_pais
      );
      //console.log(filtro)
      this.dataForm.curriculo = filtro[0].curriculo;
      this.dataForm.id_curriculo = filtro[0].id;
    },

    async confirEvent(event) {
      // Continuar Ingrsando true
      if (event) {
        this.dataForm.descripcion = "";
        this.resetValidation();
      } else {
        this.dialog = false;
      }
    },

    // Cargar los datos a listar en el data Table
    async eventCurriculo() {
      if (this.filtro.id_curriculo) {
        let habilitar = this.curriculo.filter(
          (el) => el.id == this.filtro.id_curriculo
        );
        if (habilitar[0].status) {
          this.inhabilitarIcono = false;
        } else {
          this.inhabilitarIcono = true;
        }

        let resp = await axios.get(
          `/manager/competencia/${this.filtro.id_curriculo}`
        );
        this.Datos = resp.data;
        //console.log(resp.data)
      }
    },

    //----------- AREGAR REGISTROS  --------------
    async addItem() {
      this.limpiarForm();
      this.formTitle = "Crear " + this.titulo;
      this.dialog = true;
      this.evento = "agregar";
      this.inhabilitarPais = false;
    },

    //--------------EDITAR REGISTRO--------------
    editItem(item) {
      this.limpiarForm();
      //console.log(item)
      //console.log(this.paisCurriculo)
      // this.inhabilitarPais      = false
      // this.inhabilitarCurriculo = true

      this.formTitle = "Editar " + this.titulo;
      this.dialog = true;
      this.evento = "editar";

      item.id_usuario = this.datoLogin.id;
      this.dataForm = Object.assign(this.dataForm, item);
      this.dataForm.id_us_mod = this.datoLogin.id;
      this.dataForm.id_pais = this.filtro.id_pais;
      this.filtroFormPais();
      // this.dataForm.curriculo   = this.filtro.id_curriculo
    },

    // Guardar registro
    async saveItem(id) {
      // valiadar curriculo activo
      let filtroCurriculo = this.listCurriculo.filter(
        (el) => el.id == this.dataForm.id_curriculo
      );
      //console.log(filtroCurriculo)

      if (this.$refs.formDatos.validate() && filtroCurriculo[0].status) {
        try {
          if (this.evento == "agregar") {
            const res = await axios.post("/manager/competencia/", {
              datos: this.dataForm,
            });
            console.log(res);
            this.dialog_confir = true;
          }

          if (this.evento == "editar") {
            const resp = await axios.put(
              "/manager/competencia/" + id,
              this.dataForm
            );
            this.setEnviarMens({
              tipo: resp.data.messageT,
              mensaje: resp.data.message,
              tiempo: null,
            });
            this.dialog = false;
            this.evento = null;
          }

          // Actualizar Cambios
          this.listarCompetencias();
          this.eventCurriculo();
          ///this.listarCompetencias()
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      } else if (
        filtroCurriculo[0].status == 0 ||
        filtroCurriculo[0].status == false
      ) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Debe de Seleccionar un Curriculo Activo`,
          tiempo: null,
        });
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de Ingresar todo los campos requeridos`,
          tiempo: null,
        });
      }
    },

    // activa la modal para confirmar el borrar el registro
    deleteConfirm(items) {
      this.dialog_delete = true;
      this.id_delete = items.id;
      this.desc_delete = `${items.descripcion} - (${items.id})`;
    },

    //------------BORRAR Registro -------------
    async deleteItem() {
      this.dialog_delete = false;
      try {
        let resp = await axios.delete("/manager/competencia/" + this.id_delete);
        //this.loadMain()

        this.listarCompetencias();
        this.eventCurriculo();
        this.dialog = false;

        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
  },
};
</script>
